import { COMPANY_SETTINGS_PATHS } from "@/routes/company/routes.settings";
import { MS_SETTINGS_PATHS } from "@/routes/my-space/routes.settings";
import { companyHelpSupportRoutes } from "@/routes/company/routes.help-and-support";
import { companyDocumentsRoutes } from "@/routes/company/routes.documents";
import { myspaceTeamsRoutes } from "@/routes/my-space/routes.teams";
import { myspaceEventRoutes } from "@/routes/my-space/routes.events";
import { mySpaceAssetsRoutes } from "@/routes/my-space/routes.asset";
import { mySpaceDocumentsRoutes } from "@/routes/my-space/routes.documents";
import { myspaceAIAssistantRoutes } from "@/routes/my-space/routes.ai-assistant";
import { myspaceTimeAttendanceRoutes } from "@/routes/my-space/routes.time-attendance";
import { myspaceCompanyPoliciesRoutes } from "@/routes/my-space/routes.company-policies";
import { myspaceGuidesRoutes } from "@/routes/my-space/routes.guides";
import { companyGuidesRoutes } from "@/routes/company/routes.guides";
import { myspaceLeavesManagementRoutes } from "@/routes/my-space/routes.leave-management";
import { companyTeamsRoutes } from "@/routes/company/routes.teams";
import { companyEventRoutes } from "@/routes/company/routes.events";
import { companyAssetsRoutes } from "@/routes/company/routes.asset";
import { companyEmployeesRoutes } from "@/routes/company/routes.employees";
import { companyProjectsRoutes } from "@/routes/company/routes.projects";
import { companyWorkflowsRoutes } from "@/routes/company/routes.workflow";
import { companyAnnouncementsRoutes } from "@/routes/company/routes.announcement";
import { companyNotificationsRoutes } from "@/routes/company/routes.notifications";
import { companyTimeAttendanceRoutes } from "@/routes/company/routes.time-attendance";
import { companyLeavesManagementRoutes } from "@/routes/company/routes.leave-management";
import { companySubscriptionRoutes } from "./company/routes.subscription";
import { companyPerformancetRoutes } from "./company/routes.performance";
import { myspacePerformanceRoutes } from "./my-space/routes.performance";
import { companyPayrollRoutes } from "./company/routes.payroll";
import { myspacePayrollRoutes } from "./my-space/routes.payroll";
import { companyOnboardingRoutes } from "./company/routes.onboarding";

// Main Settings (My Space + Workspace) is deliberately absent: it is a full
// page with its own sidebar, not a module that fits a split pane. The module
// picker hides it too (SPLIT_SCREEN_EXCLUDED_URLS).
export const SPLIT_SCREEN_EXCLUDED_URLS: ReadonlySet<string> = new Set([
  MS_SETTINGS_PATHS.ROOT,
  COMPANY_SETTINGS_PATHS.ROOT,
]);

export const splitScreenRoutes = [
  {
    path: "", // My Space
    children: [
      myspaceTeamsRoutes,
      myspaceEventRoutes,
      mySpaceAssetsRoutes,
      mySpaceDocumentsRoutes,
      myspaceAIAssistantRoutes,
      myspaceTimeAttendanceRoutes,
      myspaceCompanyPoliciesRoutes,
      myspaceGuidesRoutes,
      myspaceLeavesManagementRoutes,
      myspacePerformanceRoutes,
      myspacePayrollRoutes,
      // ANY NEW MODULES THAT SHOULD WORK INSIDE SPLIT SCREEN, SHOULD BE ADDED HERE
    ],
  },
  {
    path: "company",
    children: [
      companyTeamsRoutes,
      companyEventRoutes,
      companyAssetsRoutes,
      companyEmployeesRoutes,
      companyProjectsRoutes,
      companyWorkflowsRoutes,
      companyDocumentsRoutes,
      companyHelpSupportRoutes,
      companyGuidesRoutes,
      companyAnnouncementsRoutes,
      companyNotificationsRoutes,
      companyTimeAttendanceRoutes,
      companyLeavesManagementRoutes,
      companySubscriptionRoutes,
      companyPerformancetRoutes,
      companyPayrollRoutes,
      companyOnboardingRoutes,
      // ANY NEW MODULES THAT SHOULD WORK INSIDE SPLIT SCREEN, SHOULD BE ADDED HERE
    ],
  },
];
